import { loginSendOTP, loginVerifyOTP } from "@portal/api/login";
import { authAtom } from "@portal/store/auth/auth";
import { portalPreferencesAtom } from "@portal/store/preferences/preferences";
import { LoginDTO } from "@portal/types/entities/login";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue, useSetAtom } from "jotai";
import { useParams, useSearchParams } from "react-router-dom";
import { sessionStore } from "./../util/browser-storage/index";

export function useSendOtp() {
  const login_type = useAtomValue(portalPreferencesAtom).login_type;
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["send-otp"],
    mutationFn: (data: Omit<LoginDTO, "otp" | "login_type">) =>
      loginSendOTP({ ...data, login_type }),
    onSuccess(data, variables) {
      queryClient.setQueryData<Omit<LoginDTO, "otp">>(["send-otp"], {
        ...variables,
        user_id: data.id,
        login_type,
      });
    },
  });
}

export function useVerifyOtp() {
  const setAuth = useSetAtom(authAtom);
  const queryClient = useQueryClient();
  const { customer_id } = useParams();
  const [searchParams] = useSearchParams();
  const sessionId = sessionStore.getItem("customer_id");
  return useMutation({
    mutationKey: ["verify-otp"],
    mutationFn: (data: LoginDTO) => loginVerifyOTP({ ...data }),
    onSuccess(data) {
      setAuth({ authStatus: "authenticating" });
      const path = data.url.split("/").pop();
      const id = searchParams.get("customer_id");
      if (customer_id || id || sessionId) {
        queryClient.invalidateQueries(["user"]);
        return;
      }
      if (!path) return;
      sessionStore.setItem("customer_id", path);
      queryClient.invalidateQueries(["user"]);
    },
  });
}
